import { post } from '@/utils/ajax'

/**
 * 获取OJ实时判题结果
 * resultStatus: 1 成功，2 正在运行，3 运行超时，4 运行失败，5 编译失败
 * @param {Object} params
 * @param {string} params.submissionId 提交ID
 * @param {string} params.examId 考试ID
 * @param {string} params.code 代码
 * @param {string} params.questionId 题目ID
 * @returns {Promise<{
 *  resultStatus: number,
 *  pass: number,
 *  notPass: number,
 *  result: {
 *    pointResult: string,
 *    timeCost: number,
 *    memoryCost: number
 *  }[]
 * }>}
 */
export function getOjRealtimeResult(params) {
  const { submissionId, examId, code, questionId } = params
  return post(`/home/edu/examineeExamRecode/oj/time/submit`, {
    submissionId,
    examId,
    code,
    questionId
  })
}

/**
 * 获取上一次OJ实时判题结果
 * @param {Object} params
 * @param {string} params.examId 考试ID
 * @param {string} params.questionId 题目ID
 * @returns {Promise<{
 *  resultStatus: number,
 *  pass: number,
 *  notPass: number,
 *  result: {
 *    pointResult: string,
 *    timeCost: number,
 *    memoryCost: number
 *  }[]
 * }>}
 */
export function getLastOjRealtimeResult(params) {
  const { examId, questionId } = params
  return post(`/home/edu/examineeExamRecode/${examId}/${questionId}/submission`, undefined, {
    ignoreMsg: true
  })
}

/**
 * 获取上一次OJ实时判题代码
 * @param {Object} params
 * @param {string} params.examId 考试ID
 * @param {string} params.questionId 题目ID
 * @returns {Promise<{
 *  code: string
 * }>}
 */
export function getLastOjRealtimeCode(params) {
  const { examId, questionId } = params
  return post(`/home/edu/examineeExamRecode/${examId}/${questionId}/submission/code`, undefined, {
    ignoreMsg: true
  })
}
